import React, { useContext } from "react";
import "./CertificationCard.css";
import StyleContext from "../../contexts/styleContext";
import { Fade } from "react-reveal";

const CertificationCard = (props) => {
  const certificate = props.certificate;
  const { isDark } = useContext(StyleContext);
  return (
    <div>
      <Fade bottom duration={1200} distance="40px">
        <div
          className="cert-card"
          style={
            !isDark && {
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
              backgroundColor: "#fff",
            }
          }
        >
          <div className="content">
            <a
              href={
                certificate.certificate_link === ""
                  ? require(`../../assets/certificadoCertus.pdf`)
                  : certificate.certificate_link
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="content-overlay"></div>
              <div
                className="cert-header"
                style={
                  isDark
                    ? { backgroundColor: "#060B17" }
                    : { backgroundColor: "#C0C3CA" }
                }
              >
                <img
                  className="logo_img"
                  src={require(`../../assets/images/${certificate.logo_path}`)}
                  alt={certificate.alt_name}
                />
              </div>
              <div className="content-details fadeIn-top">
                <h3 className="content-title">Certificado</h3>
              </div>
            </a>
          </div>
          <div className="cert-body">
            <h2 className="cert-body-title">{certificate.title}</h2>
            <h3 className="cert-body-subtitle">{certificate.subtitle}</h3>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default CertificationCard;
